import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ghost, ArrowRight, Skull, Moon } from "lucide-react";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import ProductCard from "@/components/shop/ProductCard";

export default function HalloweenPage() {
  usePageMeta(
    "Halloween Shop — Costumes, Decor & Spooky Deals",
    "Halloween costumes, decorations, masks, spooky lights and props at closeout prices. Shop IPVALUE MARKETPLACE — serving Grand Rapids and West Michigan. Pickup in store or ships to you."
  );
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/products/collections/halloween?limit=200").then((r) => setData(r.data)).catch(() => setData({ items: [], total: 0 }));
  }, []);

  return (
    <div data-testid="halloween-page">
      {/* SPOOKY HERO */}
      <section className="relative overflow-hidden bg-[#120B1E] border-b-4 border-[#FF7A00]">
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <Moon className="absolute top-8 right-[12%] w-20 h-20 text-[#FFC220]/20" />
          <Ghost className="absolute bottom-6 left-[8%] w-24 h-24 text-white/5" />
          <Skull className="absolute top-1/3 right-[30%] w-14 h-14 text-[#FF7A00]/10 rotate-12" />
        </div>
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-16 lg:py-20 relative">
          <div className="inline-flex items-center gap-2 bg-[#FF7A00] text-[#120B1E] px-3 py-1 text-xs font-black tracking-[0.25em] uppercase">
            <Ghost className="w-3.5 h-3.5" /> Halloween Shop
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-5 text-white leading-[0.95]">
            Scary good prices.<br />
            <span className="text-[#FF7A00]">Spooky season is here.</span>
          </h1>
          <p className="mt-6 text-white/70 max-w-lg leading-relaxed">
            Costumes, masks, decorations, spooky lights and props — all at
            closeout prices. Pickup in store or have it ship to you before the big night.
          </p>
        </div>
      </section>

      {/* GRID */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-14 lg:py-20">
        {data === null ? (
          <div className="p-20 text-center ipv-eyebrow">Summoning the collection…</div>
        ) : data.items.length === 0 ? (
          <div className="text-center py-20" data-testid="halloween-empty">
            <Ghost className="w-10 h-10 mx-auto text-gray-300" />
            <div className="font-display font-black text-2xl mt-6">
              The Halloween drop is coming soon.
            </div>
            <p className="text-gray-600 mt-2">
              Check back — new spooky stock lands all season.
            </p>
            <Link to="/shop" className="btn-primary inline-flex items-center gap-2 mt-8" data-testid="halloween-empty-shop-btn">
              Shop the Floor <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        ) : (
          <>
            <div className="ipv-eyebrow text-[#FF7A00] mb-8" data-testid="halloween-count">
              {data.total} spooky find{data.total > 1 ? "s" : ""} in stock now
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {data.items.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
